module.exports = __webpack_public_path__ + "img/small.0796ee79.jpg";